import { enUS, esES, itIT, ptBR } from "@mui/x-date-pickers/locales";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import "dayjs/locale/en";
import "dayjs/locale/it";
import "dayjs/locale/es";

const MUI_PICKER_LOCALES = {
  "pt-br": ptBR,
  en: enUS,
  es: esES,
  it: itIT,
};

/** Maps i18n language code to a dayjs locale string. */
export function dayjsLocaleForI18n(lang) {
  if (!lang || typeof lang !== "string") return "pt-br";
  const normalized = lang.toLowerCase();
  if (normalized.startsWith("pt")) return "pt-br";
  if (normalized.startsWith("es")) return "es";
  if (normalized.startsWith("it")) return "it";
  return "en";
}

/** Syncs the global dayjs locale with the active i18n language. */
export function applyDayjsLocale(lang) {
  const locale = dayjsLocaleForI18n(lang);
  dayjs.locale(locale);
  return locale;
}

export function muiDatePickerLocaleTextForDayjsLocale(dayjsLocale) {
  const pack = MUI_PICKER_LOCALES[dayjsLocale] ?? enUS;
  return pack.components.MuiLocalizationProvider.defaultProps.localeText;
}

/** Props for MUI LocalizationProvider (adapter + picker labels). */
export function datePickerLocalizationForI18n(lang) {
  const adapterLocale = dayjsLocaleForI18n(lang);
  return {
    adapterLocale,
    localeText: muiDatePickerLocaleTextForDayjsLocale(adapterLocale),
  };
}
